/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:af678d36-2e8d-472b-85f5-e7c9283b18c5",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_FCS4GsIe5",
    "aws_user_pools_web_client_id": "rn33jh6je0lhghe4e4a8l9tug",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "cmsihrespezialistena-20190208155313-hostingbucket-master",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d29v40ab9b7l8c.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ihrespezisMembers-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisAds-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisFiles-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisNewsletterRecipients-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisArticles-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisConfirmationMails-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisNewsletterActivationStatus-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisSendInBlue-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisPress-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisCampaigns-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisCampaignArticles-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisEmailLog-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ihrespezisEvents-master",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "ihrespezialisten-storage-master",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "ihrespezialistenBackend",
            "endpoint": "https://zsa2hh872l.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
